import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"headline") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":5,"column":9}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "			<h2 class=\"headline\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":4,"column":24},"end":{"line":4,"column":36}}}) : helper)))
    + "</h2>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "   			<li class=\"nav-mortgage-tab-list-item column small-4\">\r\n				<a href=\"#/"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"uri") || (depth0 != null ? lookupProperty(depth0,"uri") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"uri","hash":{},"data":data,"loc":{"start":{"line":10,"column":15},"end":{"line":10,"column":22}}}) : helper)))
    + "\" data-tab=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"uri") || (depth0 != null ? lookupProperty(depth0,"uri") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"uri","hash":{},"data":data,"loc":{"start":{"line":10,"column":34},"end":{"line":10,"column":41}}}) : helper)))
    + "\" style=\"background-image: url('"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"image") : depth0)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "');\" role=\"tab\">\r\n					<span class=\"nav-tab-text\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"navTitle") || (depth0 != null ? lookupProperty(depth0,"navTitle") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"navTitle","hash":{},"data":data,"loc":{"start":{"line":11,"column":32},"end":{"line":11,"column":46}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n					<span class=\"ada-hidden ada-tab-content\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"adaText") || (depth0 != null ? lookupProperty(depth0,"adaText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"adaText","hash":{},"data":data,"loc":{"start":{"line":12,"column":46},"end":{"line":12,"column":59}}}) : helper))) != null ? stack1 : "")
    + "</span>\r\n					<span class=\"ada-hidden ada-tab-content\">"
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = ((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"local"))) && lookupProperty(stack1,"content"))) && lookupProperty(stack1,"adaContent"))) && lookupProperty(stack1,"adaTabText")), depth0)) != null ? stack1 : "")
    + "</span> \r\n				</a>\r\n   			</li>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"wrapper-nav-mortgage-overview-module\">\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":1},"end":{"line":6,"column":10}}})) != null ? stack1 : "")
    + "	<ul data-equalizer class=\"nav-mortgage-tab-list row\" tabindex=\"0\" aria-label=\""
    + ((stack1 = container.lambda(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"adaContent") : stack1)) != null ? lookupProperty(stack1,"tabsAriaLabel") : stack1), depth0)) != null ? stack1 : "")
    + "\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1)) != null ? lookupProperty(stack1,"inactive") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":8,"column":5},"end":{"line":16,"column":14}}})) != null ? stack1 : "")
    + "   	</ul>\r\n</section>\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/nav-mortgage-overview-module",
  "version": "1.0.2",
  "id": "navMortgageOverviewModule",
  "containerID": "homeLoansNavMortgageOverviewModule",
  "moduleName": "home-loans-nav-mortgage-overview-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "nav-mortgage-overview-module",
  "data": {
    "init": "navMortgageOverviewModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.8",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/*
 * nav-mortgage-overview-module
 * module_js_id: navMortgageOverviewModuleJS
 *
 * Copyright (c) 2016-7-9
 */

/**
 * @class navMortgageOverviewModule
 * @extends Module
 */
class navMortgageOverviewModule extends Module {
  /**
   * constructor
   * @param {Object} options module params
   * @param {Object} context module params
   * @returns {void}
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#navMortgageOverviewModule');
  }

  /**
   * @method updateTabState
   * @param {Object} response route
   * @returns {void}
   */
  updateTabState(response) {
    const route = response.data;
    $('.nav-mortgage-tab-list-item a').removeClass('active').closest('li').removeClass('active cnx-bold').addClass('cnx-light');
    $(`.nav-mortgage-tab-list-item a[data-tab="${route}"]`).addClass('active').closest('li').addClass('active cnx-bold').removeClass('cnx-light');
  }

  /**
   * @method init
   * @returns {void}
   */
  init() {
    this.Events.sub('HOME_LOANS_MORTGAGE_OVERVIEW_ROUTE_UPDATED', this.updateTabState.bind(this));
    this.Events.sub('HOME_LOANS_LEARNING_OVERVIEW_ROUTE_UPDATED', this.updateTabState.bind(this));
    this.addAdaTextToTabs();
  }

  /**
   * @method addAdaTextToTabs
   * @desc fix for JIRA ticked CFSSSPDLCE-19269
   * @desc ADA text added to each tab
   * @returns {void}
   */
  addAdaTextToTabs() {
    const adaTabs = this.$target.find('.ada-tab-content');
    adaTabs.each(function f1(index) {
      const replace = $(this).text().replace('{index}', index + 1);
      $(this).text(replace);
    });
  }
}
registerModuleClass({
  moduleClass: navMortgageOverviewModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { navMortgageOverviewModule as default, moduleConfig };
